// src/components/settings/HistoryPanel.jsx
//
// Every saved change, newest first: who, when, from what to what.

import React, { useEffect, useState } from 'react';
import { apiFetchJSON } from '../../api/apiClient';
import { matrixDiff } from './RoleMatrix';
import { formatValue, formatWhen } from './settingsShared';

export default function HistoryPanel({ settings, refreshKey }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiFetchJSON('/api/v2/admin/settings/history').then((d) => setRows(d.history)).catch((e) => setError(e.message));
  }, [refreshKey]);

  if (error) return <div className="ft-toolbar-error" role="alert">{error}</div>;
  if (!rows) return <div className="st-loading">Loading history…</div>;
  if (!rows.length) return <div className="bl-empty">No changes yet. Every save made here will be listed, with who made it.</div>;

  const byKey = Object.fromEntries(settings.map((s) => [s.key, s]));
  return (
    <ol className="st-history">
      {rows.map((h) => {
        const s = byKey[h.key] || { label: h.label, unit: h.unit, type: h.type };
        return (
          <li key={h.id} className="st-hist">
            <div className="st-hist-head">
              <span className="st-change-label">{h.label}</span>
              <time className="st-hist-when">{formatWhen(h.changed_at)}</time>
            </div>
            {s.type === 'role_matrix' && !h.reset ? (
              <ul className="st-matrix-diff">
                {matrixDiff(s, h.old_value, h.new_value).map((d) => (
                  <li key={d.key}>
                    <span className="st-matrix-diff-label">{d.label}</span>
                    <span className="st-change-values">
                      <span className="st-old">{d.from}</span>
                      <i className="fas fa-arrow-right" aria-label="became"></i>
                      <span className="st-new">{d.to}</span>
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="st-change-values">
                <span className="st-old">{formatValue(s, h.old_value)}</span>
                <i className="fas fa-arrow-right" aria-label="became"></i>
                <span className="st-new">{h.reset ? 'Reset to .env / default' : formatValue(s, h.new_value)}</span>
              </div>
            )}
            <div className="st-hist-by">by {h.changed_by}</div>
          </li>
        );
      })}
    </ol>
  );
}
